import React, { createContext, useContext, useState, useCallback } from "react";
import QuotationDialog from "./QuotationDialog";

const Ctx = createContext();
export const useQuote = () => useContext(Ctx);

export default function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  const openQuote = useCallback((data = {}) => { setPrefill(data); setOpen(true); }, []);
  return (
    <Ctx.Provider value={{ openQuote }}>
      {children}
      <QuotationDialog open={open} onOpenChange={setOpen} prefill={prefill} />
    </Ctx.Provider>
  );
}
